import React from "react"
import styled from "styled-components"

import { FlexColumn } from "components/box"
import { Paragraph, H4, PlainLink } from "components/text"
import { Modal, ModalProps } from "components/modal"
import { TextButton } from "components/buttons"

import { REMOVE_UNDERLINE_TEXT_CSS, FontConfigurations } from "theme"
import { baseRoutes } from "routes"

type BYPHowItWorksProps = {
  text: React.ReactNode
} & ModalProps

const Container = styled(FlexColumn).attrs({
  pb: [5, null, "1.9375rem"],
  px: 5,
  height: "100%"
})`
  max-width: 20.4375rem; /* 327px */
`

const Title = styled(H4)`
  font-size: 1.625rem;
  line-height: 1;
`

const Text = styled(Paragraph).attrs({
  mt: "5.75rem",
  mb: 7
})`
  font-size: 1rem;
`

const StyledLink = styled(PlainLink).attrs({
  ...FontConfigurations.p,
  fontSize: "1rem"
})`
  font-weight: bold;
  text-transform: uppercase;
`

const StyledTextButton = styled(TextButton)`
  font-size: 1rem !important;
  text-transform: uppercase;
  line-height: 1.5625;

  ${REMOVE_UNDERLINE_TEXT_CSS}
`

const SeparatorMobile = styled.hr`
  position: absolute;
  left: 0;
  top: 4rem;

  border: 0.375rem solid ${props => props.theme.colors.iceBlue};
  border-width: 0.1875rem;
  width: calc(100% - ${props => props.theme.space[2]});
  margin: 0;
`

const BYPHowItWorks: React.FC<BYPHowItWorksProps> = ({ text, isOpen, setIsOpen }) => {
  const handleCloseModal = () => setIsOpen(false)

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} iconColor="evergreen" borderRadius="5px" fullScreenOnMobile={false}>
      <Container>
        <FlexColumn pt={5} width="100%" position="fixed" bg="white">
          <Title width="100%" textAlign="center" color="evergreen" mb={4}>
            How It Works
          </Title>
          <SeparatorMobile />
        </FlexColumn>
        <Text>{text}</Text>
        <FlexColumn width="100%" alignItems="flex-end">
          <StyledLink underline={false} mb={5} href={baseRoutes.yourInfoConsultation()} color="seafoamBlue">
            Go straight to Consultation
          </StyledLink>
          <StyledTextButton color="astralBlue" onClick={handleCloseModal}>
            Continue choosing meds
          </StyledTextButton>
        </FlexColumn>
      </Container>
    </Modal>
  )
}

export default BYPHowItWorks
